<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
//import resize from "./mixins/resize";
import chartResize from "./mixins/chart-resize";
export default {
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "折线图",
    },
    chartData: {
      type: Object,
      required: true,
    },
    isAnnular: {
      type: String,
      default: "false",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      if (this.chartData.length <= 0) {
        this.chart.clear();
        return;
      }
      this.chart.setOption({
        title: {
          text: this.title,
          textStyle: {
            fontSize: 16,
            color: "#c0c3cd",
          },
        },
        tooltip: {
          trigger: "item",
          valueFormatter: (value) => value + " " + this.unit,
        },
        legend: {
          type: "scroll",
          // pageIcons: {
          //   vertical: [
          //     'path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z',
          //     'path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z',
          //   ],
          // },
          pageButtonPosition: "end", // 翻页的位置。'start'：控制块在左或上,end控制块在右或下。
          pageIconColor: "#29bca8", // 可以点击的翻页按钮颜色
          pageIconInactiveColor: "#7f7f7f", // 禁用的按钮颜色
          // pageIconSize: 14, //这当然就是按钮的大小
          pageTextStyle: {
            color: "#ffffff",
          },
          orient: "vertical",
          x: "right",
          y: "center",
          // icon: "circle", // 修改形状
          // itemHeight: 8, // 修改icon图形大小
          // itemWidth:8, //修改icon图形大小,默认25
          // itemGap: 10, // 修改间距
          textStyle: {
            color: "#ffffff",
          },
        },
        series: [
          {
            type: "pie",
            radius: "50%",
            label: null,
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
  },
};
</script>

